import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Button, Text } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";

export const VerticalInputFormLayout = ({
  children,
  label,
  handleSubmit,
  onSubmit,
  noMargin,
  isUpdate,
  cancelAction,
  loading = false,
}: {
  children: any;
  label: string;
  handleSubmit: any;
  onSubmit: any;
  noMargin?: boolean;
  isUpdate?: boolean;
  cancelAction?: () => void;
  loading?: boolean;
}) => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <div className="bg-primary-lightest rounded p-12 my-12">
      <Text
        component="h2"
        size="xl"
        weight="semibold"
        className="pb-5 mb-8 border-bottom"
      >
        {t(label)}
      </Text>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row pb-0 mb-0">
          {children}
          <div className={cancelAction ? "col-lg-6 col-2xl-4" : "col-xl-2"}>
            <Button
              fill="fill"
              htmlType="submit"
              type="info"
              size="sm"
              className={classNames("verticalGroupBtn", {
                verticalGroupBtnMargin: !noMargin,
              })}
              loading={loading}
              disabled={loading}
            >
              {isUpdate
                ? language === "en"
                  ? "Update"
                  : "পরিবর্তন করুন"
                : language === "en"
                ? "Add"
                : "যোগ করুন"}
            </Button>
            {isUpdate && cancelAction && (
              <Button
                htmlType="button"
                fill="outline"
                type="light"
                size="sm"
                onClick={cancelAction}
                className={classNames("verticalGroupBtn ms-8", {
                  verticalGroupBtnMargin: !noMargin,
                })}
              >
                {language === "bn" ? "বাতিল করুন" : "Cancel"}
              </Button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};
